const HOST = {
  origin: '',
  pplp: '//pplpxgpre2.cnsuning.com',
  pplpsit: '//pplpsit.cnsuning.com', // 用于判断sit环境
  pppassport: '//api.passport.pptv.com',
  pppassportsend: '//api.passport.pptv.com',
  snpassport: '//passport.suning.com',
  paypassport: '//paypassport.suning.com',
  suning: '//www.suning.com',
  pptv: '//www.pptv.com',
  wechat: '//open.weixin.qq.com',

  siller: '//dt.suning.com', // 风控拖动取值
  aq: '//aq.suning.com', // 解除风控
  vcs: '//vcs.suning.com',
  reg: '//reg.suning.com', // 一账通升级URL

  snreg: '//reg.suning.com', // 苏宁注册
  ppgateway: '//ppgateway.suning.com',

  ppsports: '//ppsports.suning.com',
  isports: '//isports.suning.com',

  mppsport: '//m.ppsport.com',
  ppgw: '//ppgw.suning.com',
  vippptv: '//api.vip.pptv.com',
  pgoods: '//pgoods.suning.com',
  pcoupon: '//pcoupon.suning.com',
  apipay: '//api.pay.pptv.com',
  porder: '//porder.suning.com',

  // 收银台 使用 prd 接口
  epg: '//epg.api.pptv.com',
  livecenter: '//livecenter.pptv.com/',
  ddp: '//api.ddp.vip.pptv.com',
  ddpas: '//ddpas.suning.com',
  // 收银台 end
  ppwfs: '//ppwfspre.cnsuning.com',
};

const ENV = 'pre2';

export {
  HOST,
  ENV,
};
